import React from 'react';
import PropTypes from 'prop-types';
import {Button} from "../../../../../components/Button";

// const weekDay = {
//
// }

const ButtonsBlock = (props) => {
  const {
    days,
    selectedDays,
    usedDays,
    setSelectedDays,
  } = props;
  return (
    <div className="tour-schedule__days-list">
      {
        days.map((item, index) => {
          const isSelected = selectedDays[index] ? 'active_button' : '';
          const isUsed = usedDays[index] ? 'button__disabled' : '';
          return (
            <Button
              name={item}
              className={`${isSelected} ${isUsed}`}
              onClick={() => setSelectedDays(index)}
              key={`day-btn-${item}`}
              disabled={usedDays[index]}
            />
          )
        })
      }
    </div>
  )
};

ButtonsBlock.propTypes = {
  days: PropTypes.array,
  selectedDays: PropTypes.object,
  setSelectedDays: PropTypes.func,
  usedDays: PropTypes.object,
};

ButtonsBlock.defaultProps = {
  selectedDays: {},
  usedDays: {}
};

export default ButtonsBlock


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/TimeSlots/ButtonsBlock.js